import { RefObject, useCallback, useRef } from 'react';

import { HEADER_MAX_HEIGHT, HEADER_REGULAR_HEIGHT } from '@/blocks/sections/Header/Components/HeaderInner';

const DEFAULT_GAP_AFTER_HEADER = 20;

export const useScrollTo = (params?: ScrollToOptions & { gap?: number }) => {
  // prettier-ignore
  const {
    gap,
    ...scrollToOptions
  } = {
    gap: DEFAULT_GAP_AFTER_HEADER,
    behavior: 'smooth',
    ...params,
  };

  const scrollRef = useRef<HTMLDivElement>(null);

  const scrollToElement = useCallback((el?: RefObject<HTMLElement>, options?: ScrollToOptions) => {
    const elementToScroll = el?.current || scrollRef.current;

    if (!elementToScroll) {
      return;
    }

    const header = document.querySelector('header');
    const bigHeader = header && header.childNodes.length > 1;
    const headerHeight = bigHeader ? HEADER_MAX_HEIGHT : HEADER_REGULAR_HEIGHT;
    const bannerHeight =
      parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--height-app-banner')) || 0;

    const top =
      elementToScroll.getBoundingClientRect().top + window.scrollY - headerHeight - bannerHeight - gap;

    window.scrollTo({ top, ...(scrollToOptions as ScrollToOptions), ...options });
    // eslint-disable-next-line
  }, []);

  return {
    scrollRef,
    scrollToElement,
  };
};
